import { render, staticRenderFns } from "./exportLecto.vue?vue&type=template&id=516a8bc6&scoped=true"
import script from "./exportLecto.vue?vue&type=script&lang=js"
export * from "./exportLecto.vue?vue&type=script&lang=js"
import style0 from "./exportLecto.vue?vue&type=style&index=0&id=516a8bc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a8bc6",
  null
  
)

export default component.exports